
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeSerialGrid extends Serenity.EntityGrid<PsDiscCouponTypeSerialRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeSerialColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeSerialDialog; }
        protected getIdProperty() { return PsDiscCouponTypeSerialRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeSerialRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeSerialRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeSerialService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}